import { ChangeDetectionStrategy, Component, forwardRef, HostBinding, input, output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';

export enum CompaniesHierarchyFilter {
  All = 'all',
  Parent = 'parent',
}

@Component({
  selector: 'idl-companies-hierarchy-toggle',
  imports: [
    MatButtonToggleModule,
    ReactiveFormsModule,
    TranslocoPipe
  ],
  templateUrl: './companies-hierarchy-toggle.component.html',
  styleUrl: './companies-hierarchy-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompaniesHierarchyToggleComponent),
      multi: true,
    },
    provideTranslocoScope('sharedComponents')
  ]
})
export class CompaniesHierarchyToggleComponent implements ControlValueAccessor {
  height = input('40px');

  @HostBinding('style.--toggle-height')
  get toggleHeight() {
    return this.height();
  }

  valueChanged = output<void>();
  public companiesFilterControl = new FormControl<string>(CompaniesHierarchyFilter.All);

  private onChange: (value: string) => void = () => {
  };
  private onTouched: () => void = () => {
  };

  constructor() {
    this.companiesFilterControl.valueChanges.subscribe(value => {
      this.onChange(value ?? CompaniesHierarchyFilter.All);
    });
  }

  writeValue(value: string): void {
    this.companiesFilterControl.setValue(value, {emitEvent: false});
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.companiesFilterControl.disable();
    } else {
      this.companiesFilterControl.enable();
    }
  }

  protected readonly CompaniesHierarchyFilter = CompaniesHierarchyFilter;
}
